import React, {useMemo} from 'react';

const Pager = ({page, onPageChange, pageCount, data}) => {
  const linkArray = useMemo(() =>{
    const links = [0,];
    if (page > 2) {
        links.push('ellipsis');
    }
    if (page < 3 ) {
        if (pageCount > 1 && 1 !== pageCount - 1) {
            links.push(1);
        }
        if (pageCount > 2 && 2 !== pageCount - 1) {
            links.push(2);
        }
        if (pageCount > 3 && 3 !== pageCount - 1) {
            links.push(3);
        }
        if (pageCount > 4 && 4 !== pageCount - 1) {
            links.push(4);
        }
    } else if (pageCount - 1 - page < 3) {
        if (pageCount > 4) {
            links.push(pageCount - 1 - 4);
        }
        if (pageCount > 3) {
            links.push(pageCount - 1 - 3);
        }
        if (pageCount > 2) {
            links.push(pageCount - 1 - 2);
        }
        if (pageCount > 1) {
            links.push(pageCount - 1 - 1);
        }
    } else {
        links.push(page - 2);
        links.push(page - 1);
        if (page != pageCount - 1) {
            links.push(page);
        }
        if (page + 1 != pageCount - 1) {
            links.push(page + 1);
        }
        if (page + 2 != pageCount - 1) {
            links.push(page + 2);
        }
    }
    if (pageCount - 1 - page > 2) {
        links.push('ellipsis');
    }
    links.push(pageCount - 1);

    // Remove duplicate, like [0, "ellipsis", 0, 1...]
    const uniqueLinks = Array.from(new Set(links))

    return uniqueLinks
  }, [page])

  const prevAttr = page === 1 && {disabled: true}
  const nextAttr = page === pageCount && {disabled: true}

  return (
    <nav className="crtPagination" role="navigation" aria-label="Pagination Navigation">
      <button className="crtPagination-btn" onClick={() => onPageChange(page - 1)} {...prevAttr} >
        <svg viewBox="0 0 100 100" className="crt-left"><use xlinkHref="#crt-left"></use></svg>
        <span className="crtPagination-btnLabel">{data.previousWording}</span>
      </button>
      <ol className="crtPagination-list">
        {
          linkArray.map((element, key) => {
            return (
              element === 'ellipsis' ? <li key={key} className="crtPagination-item">…</li> :
              <li
                key={key}
                className={`crtPagination-item${element === page - 1 ? ' is-current' : ''}`}
                aria-current={element === page ? true : false}
              >
                <button
                  aria-label={`${data.gotoWording} ${element + 1}`}
                  className="crtPagination-link"
                  onClick={() => onPageChange(element+1)}
                >
                  {element + 1}
                </button>
              </li>
            )
          })
        }
      </ol>
      <button className="crtPagination-btn" onClick={() => onPageChange(page + 1)} {...nextAttr}>
        <span className="crtPagination-btnLabel">{data.nextWording}</span>
        <svg viewBox="0 0 100 100" className="crt-right"><use xlinkHref="#crt-right"></use></svg>
      </button>
    </nav>
  )
}

export default Pager
